module.exports = __webpack_public_path__ + "img/mehr-iran.2ec5e313.png";